import React from "react";
import Insurer from "../../../types/Entities/Insurer";
import { PARTNER_INSURER } from "../../../services/insurersList";
import HighlightBox from "../../Box/HighlightBox/HighlightBox";

type LegalExpenseInsuranceDisclaimerProps = {
  insurer: Insurer | null | undefined;
  deductibleMayApply: boolean;
};

export default function LegalExpenseInsuranceDisclaimer({ insurer, deductibleMayApply }: LegalExpenseInsuranceDisclaimerProps) {
  if (!insurer) {
    return null;
  }

  if (deductibleMayApply) {
    return (
      <HighlightBox>
        {`Die ${insurer.name} übernimmt die Kosten des behördlichen Verfahrens gemäß Ihren Versicherungsbedingungen. Eine eventuell anfallende Selbstbeteiligung tragen Sie selbst.`}
      </HighlightBox>
    );
  }

  let disclaimerText;
  switch (insurer.id) {
    case PARTNER_INSURER.ARAG:
      disclaimerText = "Sie sind bei der ARAG rechtsschutzversichert - daher ist das behördliche Verfahren für Sie komplett kostenlos!";
      break;
    case PARTNER_INSURER.ADVOCARD:
      disclaimerText = "Sie sind bei der Advocard rechtsschutzversichert, daher ist das weitere Vorgehen für Sie komplett kostenlos!";
      break;
    default:
      disclaimerText = "Sie sind rechtsschutzversichert, daher ist das weitere Vorgehen für Sie komplett kostenlos!";
      break;
  }

  return <HighlightBox>{disclaimerText}</HighlightBox>;
}
